// @flow
import client from '../../client'

// API Endpoints
export const TRAVEL_AGENT_ENDPOINT = '/travel_agent/'

// Types
export type TCompany = {
  company_code: string,
  id: number,
  name: string,
  payout_to_master: boolean,
  use_master_commission: boolean,
}

export type BankAccount = {
  account_id: number,
  bank_name: string,
  last4: string,
}

export type PaypalAccount = {
  account_id: number,
  paypal_email: string,
}

export type Reservation = {
  airline: string,
  airport_terminal: ?string,
  amount_paid: string,
  branch: ?string,
  campaign: ?string,
  can_cancel: boolean,
  cancelled: boolean,
  confirmation_number: string,
  contact_email: string,
  contact_phone: string,
  currency: string,
  customer_special_instructions: ?string,
  first_name: string,
  flight_number: string,
  gratuity: string,
  gross_revenue_usd: string,
  id: string,
  last_name: string,
  mozio_profit_usd: string,
  partner_profit_usd: string,
  partner_tracking_id: ?string,
  pickup_instructions: string,
  provider: Object,
  voyage: Object,
}

export type TTravelAgent = {
  bank_accounts: Array<BankAccount>,
  credit_cards: Array<any>,
  past_reservations: Array<Reservation>,
  paypal_accounts: Array<PaypalAccount>,
  reservations: Array<Reservation>,
  user: {
    commision: number,
    company: TCompany,
    country: string,
    country_code: string,
    country_code_name: string,
    currency: string,
    email: string,
    first_name: string,
    id: number,
    last_name: string,
    phone_number: string,
    phone_number_national: string,
    position: number,
    tax_id: string,
    user_type: number,
  },
}

/**
 * Registers a travel agent
 * @param {Object} data Travel agent information
 * @param {string} data.first_name Travel agent first name
 * @param {string} data.last_name Travel agent last name
 * @param {string} data.password Travel agent password
 * @param {string} data.email Travel agent email
 * @param {string} [data.country] Country
 * @param {string} [data.currency] Currency
 * @param {string} [data.company_name] Travel agent company name
 * @param {string} [data.company_code] Travel agent company code
 * @param {string} [data.country_code_name] Country code name
 * @param {string} [data.phone_number_national] Travel agent phone number
 * @param {number} [data.commision] Travel agent comission
 * @param {string} [data.ref] Ref
 * @param {string} [data.partner] Partner
 * @param {string} [data.referral] Referral
 * @returns {Promise<TTravelAgent> | Error} A resolved Promise with the profile created or Rejected with an Error
 */
export const register = (data: {
  first_name: string,
  last_name: string,
  password: string,
  email: string,
  country?: string,
  currency?: string,
  company_name: string,
  company_code: string,
  country_code_name?: string,
  phone_number_national?: string,
  commision?: number,
  ref?: string,
  partner?: string,
  referral?: string,
}): Promise<TTravelAgent> => client.post(TRAVEL_AGENT_ENDPOINT, { body: data })

export default register
